(() => {
  if (customElements.get('tf-standard')) return;
  customElements.define('tf-standard', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const trigger = this.querySelector('[data-standard-promise]');
      const dialog = this.querySelector('dialog');
      if (!trigger || !dialog || typeof dialog.showModal !== 'function') return;
      trigger.addEventListener('click', (event) => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        dialog.showModal();
      });
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
    }
  });
})();
